(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
(() => {
  const autoplayDelay = 4000;
  const timers = new WeakMap();

  const stop = (section) => {
    const timer = timers.get(section);

    if (timer) {
      window.clearInterval(timer);
      timers.delete(section);
    }
  };

  const advance = (section) => {
    if (document.hidden) {
      return;
    }

    const selectedLook = section.querySelector('shop-the-look-desktop-carousel .shop-the-look__item.is-selected');

    if (!selectedLook) {
      return;
    }

    const carousel = selectedLook.querySelector('shop-the-look-product-list-carousel');
    const navigation = selectedLook.querySelector('carousel-navigation.page-dots');

    if (!carousel || !navigation) {
      return;
    }

    const slides = Array.from(carousel.children).filter((slide) => slide.classList.contains('shop-the-look__item-product'));
    const buttons = Array.from(navigation.querySelectorAll('button'));

    if (slides.length < 2 || buttons.length !== slides.length) {
      return;
    }

    const selectedIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-selected')));
    const nextIndex = (selectedIndex + 1) % slides.length;

    slides.forEach((slide, index) => slide.classList.toggle('is-selected', index === nextIndex));
    buttons.forEach((button, index) => button.setAttribute('aria-current', index === nextIndex ? 'true' : 'false'));

    const productLink = slides[nextIndex].querySelector('a.product-card__media, a.product-title');
    const viewProductButton = selectedLook.querySelector('.shop-the-look__item-content > a.button');

    if (productLink && viewProductButton) {
      viewProductButton.href = productLink.href;
    }
  };

  const start = (section) => {
    stop(section);
    timers.set(section, window.setInterval(() => advance(section), autoplayDelay));
  };

  const initialize = (section) => {
    if (section.dataset.productCarouselAutoplay === 'true') {
      return;
    }

    section.dataset.productCarouselAutoplay = 'true';
    start(section);
  };

  const initializeAll = (root = document) => {
    if (root.matches?.('.shopify-section--shop-the-look')) {
      initialize(root);
    }

    root.querySelectorAll('.shopify-section--shop-the-look').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => stop(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
